(function() {

const hamburger = document.querySelector('.hamburger');
const nav = document.querySelector('.nav');
const hero = document.querySelector('.hero-section');
const headerLogo = document.querySelector('.header-logo'); 


hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('active');
    nav.classList.toggle('active');
});


window.addEventListener('scroll', () => {
    if (hero) {
        const heroHeight = hero.offsetHeight;
        
        if (window.scrollY > heroHeight - 80) { 
            headerLogo.classList.add('visible');
        } else {
            headerLogo.classList.remove('visible');
        }
    }
});


document.querySelectorAll('.nav a').forEach(link => {
    link.addEventListener('click', () => {
        hamburger.classList.remove('active');
        nav.classList.remove('active');
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const revealEls = document.querySelectorAll('.scroll-reveal');
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            }
        });
    }, { threshold: 0.1 });

    revealEls.forEach(el => observer.observe(el));
});

document.addEventListener('DOMContentLoaded', function() {
    const revealOptions = {
        threshold: 0.1, 
        rootMargin: "0px 0px -50px 0px" 
    };

    const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-active');
                
                revealObserver.unobserve(entry.target);
            }
        });
    }, revealOptions);

    
    document.querySelectorAll('.reveal-fade').forEach(el => {
        revealObserver.observe(el);
    });
});

})();